/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { ClickablePresentationProps } from "@insite/mobius/Clickable";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { IconPresentationProps } from "@insite/mobius/Icon";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

interface SalesRepComponentStyles {
    container: GridContainerProps;
    gridItem: GridItemProps;
    title: TypographyPresentationProps;
    divider: InjectableCss;
}

interface SalesRepStyles {
    SRImage: InjectableCss;
    SRName: TypographyPresentationProps;
    SRPhoneNumber: LinkPresentationProps;
    SREmail: LinkPresentationProps;
    SRChat: ClickablePresentationProps;
    SRContainer: InjectableCss;
    SRLeftContainer: InjectableCss;
    SRRightContainer: InjectableCss;
    icon: IconPresentationProps;
}

export const salesRepComponentStyles: SalesRepComponentStyles = {
    container: {
        gap: 0,
        css: css`
            max-width: 330px !important;
            flex-direction: column;

            && div[class*="GridOffset-sc"] {
                max-width: 100%;
            }
        `,
    },
    gridItem: {
        width: 12,
        css: css`
            &.addMargin {
                margin-bottom: 20px !important;
            }
        `,
    },
    title: {
        css: css`
            font-size: 20px;
            font-weight: normal;
            line-height: 20px;
            border-bottom: 1px solid ${getColor("common.ui4")};
            display: block;
            padding-bottom: 5px;
            margin-bottom: 12px;
        `,
    },
    divider: {
        css: css`
            margin: 20px 0;
            width: 100%;
            border-bottom: 1px solid ${getColor("common.ui4")};
        `,
    },
};
export const salesRepStyles: SalesRepStyles = {
    SRName: {
        weight: 600,
        color: "text.main",
        css: css`
            letter-spacing: 0.3px;
            margin-bottom: 5px;
            font-size: 14px;
            line-height: 20px;
        `,
    },
    SRPhoneNumber: {
        color: "primary",
        css: css`
            letter-spacing: 0.3px;
            margin-bottom: 5px;
            font-size: 12px;
            font-weight: normal;
            line-height: 14px;
            margin-bottom: 5px;
        `,
    },
    SREmail: {
        color: "primary",
        css: css`
            letter-spacing: 0.3px;
            margin-bottom: 5px;
            font-size: 12px;
            font-weight: normal;
            line-height: 14px;
        `,
    },
    SRChat: {
        css: css`
            margin-top: auto;
            font-size: 12px;
            color: ${getColor("primary")};
            line-height: 16px;
        `,
    },
    SRContainer: {
        css: css`
            display: flex;
        `,
    },
    SRLeftContainer: {
        css: css`
            display: flex;
            justify-content: center;
            margin-right: 10px;
            border: 1px solid ${getColor("common.ui4")};

            ${(props: any) => {
                if (props.smallImageSize) {
                    return `
                        width: 85px;
                        height: 85px;
                    `;
                }
                return `
                    width: 110px;
                    height: 110px;
                `;
            }}
        `,
    },
    SRImage: {
        css: css`
            max-width: 100%;
            max-height: 100%;
            width: auto;
            height: auto;
        `,
    },
    SRRightContainer: {
        css: css`
            display: flex;
            flex-direction: column;
            // EIS-4192 - to avoid default address italic style
            font-style: normal;
        `,
    },
    icon: {
        css: css`
            margin-left: 10px;
            &,
            * {
                color: ${getColor("primary")};
                fill: ${getColor("primary")};
            }
        `,
    },
};
